import { Nodo, Sector } from "../../mantenimiento-operaciones";
import { City } from "../../system-settings";
import { OLT } from "../olt";





export interface Ipv4PagingRes {
  last_id: number;
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: Ipv4[];
}



export interface Ipv4 {
  id_ipv4?:string;
  estado: boolean;
  codigo: string,
  numero_referencia: string,
  estado_ip: EstadoIpv4,
  ip: string,
  grupo_ipv4: string
  contrato: string
  fecha_modificacion?:string;
  fecha_creacion?:string;
}

export type Ipv4Extended = Partial<Ipv4> & {
    nodo_data?: Nodo;
    olt_data?: OLT;
    sector_data?: Sector;
    ciudad_data?: City;
}

export enum EstadoIpv4 {
  DISPONIBLE= "DISPONIBLE",
  NO_DISPONIBLE= "NO DISPONIBLE",
  EN_MANTENIMIENTO= "EN MANTENIMIENTO",
  RESERVADO= "RESERVADO",
  EN_USO= "EN USO",
}


export const EstadoIpv4Choices = [
  EstadoIpv4.DISPONIBLE,
  EstadoIpv4.NO_DISPONIBLE,
  EstadoIpv4.EN_MANTENIMIENTO,
  EstadoIpv4.RESERVADO,
  EstadoIpv4.EN_USO,
]